import { post, patch, get, delete as axiosDelete } from 'axios'
import { AUTH_BASE_ENDPOINT, API_BASE_ENDPOINT } from './endpoints'
import submitForm from 'submit-form'
import config from '@source/config'

//REGISTER V1
const createNewUser = ({ email = '', password = '', csrf = '', birthdate = '', gender = '', phone = '' }) => {
  const body = { email, password }
  if (gender) {
    body.gender = gender
  }
  if (phone) {
    body.phone = phone
  }
  if (birthdate) {
    body.birthdate = birthdate
  }
  return post(`${API_BASE_ENDPOINT}/accounts/signup`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

// REGISTER V2
const userRegister = ({ email = '', password = '', csrf = '', phone = '' }) => {
  const body = {}
  if (phone) {
    body.phone = phone
    body.method = 'sms'
  }
  if (email) {
    body.email = email
    body.password = password
  }
  return post(`${API_BASE_ENDPOINT}/accounts/signup/${email ? 'email' : 'phone'}`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

// VERIFY SIGNUP OTP V2
const verifyRegister = ({ email = '', password = '', csrf = '', phone = '', otp = '' }) => {
  const body = { otp }
  if (phone) {
    body.phone = phone
    body.method = 'sms'
  }
  if (email) {
    body.email = email
    body.password = password
  }
  return post(`${API_BASE_ENDPOINT}/accounts/signup/${email ? 'email' : 'phone'}/verify`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

//verify login otp v2
const verifyPhoneLogin = (
  { phone = '', otp = '', app_key = '', grant_type = '', scope = '', csrf },
  verifyUrl,
  verifyHeader = {},
) => {
  const body = { phone, otp, app_key, grant_type, scope }
  return post(verifyUrl, body, {
    headers: {
      'x-csrf-token': csrf,
      ...verifyHeader,
    },
    withCredentials: true,
  })
    .then(response => {
      console.log('Response verify phone login', response)
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      console.log('Error verify phone login', error.response)
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const fetchProfile = ({ csrf = '', at = '' }) => {
  return get(`${AUTH_BASE_ENDPOINT}/v2/profile`, {
    headers: {
      'x-csrf-token': csrf,
      Authorization: `Bearer ${at}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const updateProfile = ({
  name = '',
  csrf = '',
  birthdate = '',
  gender = '',
  location = '',
  token = '',
  phone = '',
}) => {
  const body = {}
  if (name) {
    body.name = name
  }
  if (gender) {
    body.gender = gender
  }
  if (phone) {
    body.phone = phone
  }
  if (location) {
    body.location = location
  }
  if (birthdate) {
    body.birthdate = birthdate
  }
  return patch(`${AUTH_BASE_ENDPOINT}/v2/profile`, body, {
    headers: {
      'x-csrf-token': csrf,
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const verifyUserToken = ({ token = '', email = '', csrf = '' }) => {
  const body = { token, email }
  return post(`${API_BASE_ENDPOINT}/accounts/signup/otp/verify`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(() => {
      return {
        meta: {
          status: 'success',
        },
        data: {},
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const resendUserToken = ({ email = '', csrf = '' }) => {
  const body = { email }
  return post(`${API_BASE_ENDPOINT}/accounts/signup/otp/resend`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(() => {
      return {
        meta: {
          status: 'success',
        },
        data: {},
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const requestLogin = ({ email = '', password = '', csrf = '' }) => {
  const body = { email, password }
  return post(`${AUTH_BASE_ENDPOINT}/v1/login`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const requestLogout = ({ uid = '', csrf = '' }) => {
  const body = { uid }
  return post(`${AUTH_BASE_ENDPOINT}/v1/logout`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const emailForgotPassword = ({ email = '', csrf = '' }) => {
  const body = { email }
  return post(`${AUTH_BASE_ENDPOINT}/v2/password/forgot`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const verifyPasswordToken = ({ email = '', token = '', csrf = '' }) => {
  const body = { email, otp: token }
  return post(`${AUTH_BASE_ENDPOINT}/v2/password/validate`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const verifyPassword = ({ csrf = '', password = '' }) => {
  const body = { password }
  return post(`${AUTH_BASE_ENDPOINT}/v1/password/token`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const validateOldPassword = ({ password = '', csrf = '', token = '' }) => {
  const body = { oldPassword: password }
  return post(`${AUTH_BASE_ENDPOINT}/v2/password/old`, body, {
    headers: {
      'x-csrf-token': csrf,
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const updateNewPassword = ({ password = '', csrf = '' }) => {
  const body = { newPassword: password }
  return post(`${AUTH_BASE_ENDPOINT}/v2/password`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

// const { oauth: { appKey, appSecret }, endpoints: { domain } } = config

// const requestGuestToken = () => {
//   return get(`${AUTH_BASE_ENDPOINT}/v1/guest/token`, {
//     params: {
//       app_key: appKey,
//     },
//   })
//     .then(response => {
//       const { access_token, expires_in, token_type } = response.data.data
//       return {
//         meta: {
//           status: 'success',
//         },
//         data: {
//           token: access_token,
//           expire: expires_in,
//           type: token_type,
//         },
//       }
//     })
//     .catch(error => {
//       return {
//         meta: {
//           status: 'error',
//           error: error.response,
//         },
//         data: undefined,
//       }
//     })
// }

// const requestCode = () => {
//   const state = Math.random()
//     .toString()
//     .substr(2)
//   const json = {
//     app_key: appKey,
//     response_type: 'code',
//     redirect_uri: `${domain}/oauth/callback`,
//     scope: [
//       'https://internal.supersoccer.tv/users/users.profile.read',
//       'https://internal.supersoccer.tv/subscriptions/users.read' /* DARI CODINGAN LAMA */,
//       'https://internal.supersoccer.tv/subscriptions/users.read.global' /* DARI VINCENT */,
//       'https://api.supersoccer.tv/subscriptions/subscriptions.read' /* DARI VINCENT */,
//       'https://api.supersoccer.tv/videos/videos.read' /* DARI CODINGAN LAMA */,
//       'paymentmethods:read.internal',
//     ].join(' '),
//     state,
//   }
//   return get(`${AUTH_BASE_ENDPOINT}/oauth2/v1/authorize`, {
//     params: json,
//   })
//     .then(response => {
//       console.log(response)
//       return response.data
//     })
//     .catch(error => {
//       return null
//     })
// }

const fetchConsentList = ({ csrf = '' }) => {
  return new Promise((resolve, reject) => {
    get(`${AUTH_BASE_ENDPOINT}/oauth2/v1/consent`, {
      headers: {
        'x-csrf-token': csrf,
      },
    })
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        return resolve(null)
      })
  })
}

const authorizeConsent = ({ csrf = '' }) => {
  submitForm(`${AUTH_BASE_ENDPOINT}/oauth2/v1/consent/authorize`, {
    method: 'POST',
    body: {
      _csrf: csrf,
    },
  })
}

const denyConsent = ({ csrf = '' }) => {
  submitForm(`${AUTH_BASE_ENDPOINT}/oauth2/v1/consent/deny`, {
    method: 'POST',
    body: {
      _csrf: csrf,
    },
  })
}

const getDeviceList = ({ token = '' }) => {
  const body = {}
  return post(`${AUTH_BASE_ENDPOINT}/v2/device`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

// const getCurrentDevice = ({ token = '' , udi = '', device_id = '', usr = ''}) => {
//   const body = {}
//   if(udi){
//     body.udi = udi
//   }
//   if(device_id){
//     body.device_id = device_id
//   }
//   if(usr){
//     body.usr = usr
//   }
//   return post(`${AUTH_BASE_ENDPOINT}/v2/device/current`, body, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     }
//   })
//     .then(response => {
//       return {
//         meta: {
//           status: 'success',
//         },
//         data: response.data,
//       }
//     })
//     .catch(error => {
//       return {
//         meta: {
//           status: 'error',
//           error: error.response.data,
//         },
//         data: {},
//       }
//     })
// }

const registerDevice = ({ token = '' }) => {
  const body = {}
  return post(`${AUTH_BASE_ENDPOINT}/v2/device/create`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const getDeviceByUdi = ({ udi }) => {
  return get(`${AUTH_BASE_ENDPOINT}/v2/device/udi/${udi}`, {
    //...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const updateDeviceByUdi = ({ udi = '', alias = '', token = '' }) => {
  const body = { alias: alias }
  return patch(`${AUTH_BASE_ENDPOINT}/v2/device/${udi}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

// const setDeviceDefaultByUdi = ({
//   udi = '',
//   token = '',
// }) => {
//   return patch(`${AUTH_BASE_ENDPOINT}/v2/device/${udi}/default`, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   })
//     .then(response => {
//       return {
//         meta: {
//           status: 'success',
//         },
//         data: response.data,
//       }
//     })
//     .catch(error => {
//       return {
//         meta: {
//           status: 'error',
//           error: error.response.data,
//         },
//         data: {},
//       }
//     })
// }

const removeDeviceByUdi = ({ udi = '', token = '', currentUdi = '' }) => {
  const body = currentUdi ? { udi: currentUdi } : {}
  return axiosDelete(`${AUTH_BASE_ENDPOINT}/v2/device/${udi}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: body,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const getDeviceInfo = ({ token = '' }) => {
  return get(`${AUTH_BASE_ENDPOINT}/v2/device/info`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const requestLoginPhone = ({ phone = '', csrf = '' }) => {
  const body = { phone }
  return post(`${AUTH_BASE_ENDPOINT}/v2/login/sms`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const validateEmailPhoneNumber = ({ phone = '', email = '', csrf = '' }) => {
  const body = {}
  if (phone) {
    body.phone = phone
  }
  if (email) {
    body.email = email
  }
  return post(`${AUTH_BASE_ENDPOINT}/v2/status`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const generateEmailPhoneOtp = ({ phone = '', email = '', token = '' }) => {
  const body = {}
  if (phone) {
    body.phone = phone
  }
  if (email) {
    body.email = email
  }
  return post(`${AUTH_BASE_ENDPOINT}/v2/profile/${email ? 'email' : 'phone'}/otp`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const validateEmailPhoneOtp = ({ phone = '', email = '', password = '', otp = '', token = '' }) => {
  const body = {}
  body.otp = otp
  if (phone) {
    body.phone = phone
  }
  if (email) {
    body.email = email
    body.password = password
  }
  return post(`${AUTH_BASE_ENDPOINT}/v2/profile/${email ? 'email' : 'phone'}/verify`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

const reverifyRegister = ({ email = '', password = '', csrf = '' }) => {
  const body = { email, password }

  return post(`${API_BASE_ENDPOINT}/accounts/signup/email/reverify`, body, {
    headers: {
      'x-csrf-token': csrf,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.response.data,
        },
        data: {},
      }
    })
}

export default {
  createNewUser,
  verifyUserToken,
  resendUserToken,
  requestLogin,
  requestLogout,
  emailForgotPassword,
  verifyPasswordToken /* Verify password upon create new account */,
  verifyPassword /* Verify password after login */,
  updateNewPassword,
  fetchProfile,
  updateProfile,
  fetchConsentList,
  authorizeConsent,
  denyConsent,
  validateOldPassword,
  // requestGuestToken,
  // requestCode,
  getDeviceList,
  //getCurrentDevice,
  registerDevice,
  getDeviceByUdi,
  updateDeviceByUdi,
  //setDeviceDefaultByUdi,
  removeDeviceByUdi,
  getDeviceInfo,
  requestLoginPhone,
  validateEmailPhoneNumber,
  generateEmailPhoneOtp,
  validateEmailPhoneOtp,
  userRegister,
  verifyRegister,
  verifyPhoneLogin,
  reverifyRegister,
}
